<template>
    <router-view/>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'app',
  components: {
  },
  data: () => ({
  }),
  computed: {
  },
  created: function () {
    this.setup();
  },
  mounted: function () {
  },
  methods: {
    ...mapActions(['evalManagerDispatch', 'appManagerDispatch']),
    setup: async function () {
      await this.appManagerDispatch({action: "setup"});
      await this.evalManagerDispatch({action: "setup"});
    }, 
  }
}
</script>
<style scoped>
</style>
